/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PaintbrushThinRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB40lEQVR4nO2UPUscURSGx0L8KCT4QcCUMYKdhdraCA7unI8J3DlnFdluKxURG7tgIaRRxL+gEpb8gARFQfFfBO20EHcFC01QlDu76u64OxvHLT1wYbhz53nPPeed4zjvUQqiyUFg/QGkm4ja6zQqXHeqA0jWgfQWWe/DRbLdEDj6gQLJ6RP4SUBzbwIDmD5g+fUCzHoPJHfM6ZFEYGNMG5B8Q9abavBS9huJ4Ig6hKzHNcFF+BlR5sOr4czTXUB6GQu3yw+mEmUPpPP14MC65zhOUyIBZN2NhZP+ZZaBRHDP89otIL72suIkDdd1W4D0T0xpTmwSr/I4svy0TQWWArKsMctnC3oJl4LnB8P/DWeWfiC9qJLlVihSvMkNkv5GX+eMMZ3gq1v86SQPpFe2X0TBOLAeIclhhYDNvHYpZDWbzTaPZjKtz+d1uZ67KssT63XJl58lSk+URsM/ZFnwvHR3KmU+AetSca+KAJJcx1jxoiIZ1p2S8ELZ3lHNGyAGY3XGQC5y27BXNvOyBA8jvTuoqRwpz3nqa/pLpF95+86OkbruiSqXleUytCyYvug3wLofLVFDA1HxsckeySKAfnSN6QmfWQrAMvN2EZbvMaaYbchNgIXsJA2tSXJt3WV/vscDD3l9thKJDIjQAAAAAElFTkSuQmCC)
 */
export const PaintbrushThinRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m11.33 14.83-2.16-2.16a1 1 0 0 1-.25-.99l.75-2.57A3 3 0 0 1 11 7.4l8.05-4.91a1.8 1.8 0 0 1 2.47 2.47L16.61 13a3 3 0 0 1-1.72 1.32l-2.57.75a1 1 0 0 1-.99-.25ZM8.74 13.57c-.2-.2-.44-.36-.7-.43a4 4 0 0 0-5 4.42C3.14 18.23 2.68 19 2 19a1 1 0 1 0 0 2h5a4 4 0 0 0 3.86-5.03c-.07-.27-.23-.51-.43-.7l-1.7-1.7ZM19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16Z"
        className={colorClass}
      />
    </svg>
  );
};
